/* @ngInject */
const saleRun = (
  $transitions,
  storageHandler,
  $$sale,
  $$piece,
  $$axletree,
  $$sterile,
  $$area,
  $$railway,
  routes,
  $$wagon,
  toaster,
) => {
  $transitions.onSuccess({
    entering: routes.scrapping.sale.consult.path,
  }, (trans) => {
    if (storageHandler.get('scrapping.sale.consult')) {
      $$sale.data.mySales = storageHandler.get('scrapping.sale.consult')
    } else {
      $$sale.data.mySales.splice(0, $$sale.data.mySales.length)
    }
  })

  $transitions.onBefore({
    from: routes.scrapping.sale.consult.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('scrapping.sale.consult', $$sale.data.mySales)
      $$sale.data.mySales.splice(0, $$sale.data.mySales.length)
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.new.path,
  }, (trans) => {
    if (storageHandler.get('scrapping.sale.new')) {
      $$sale.data.mySale = storageHandler.get('scrapping.sale.new')
    } else {
      $$sale.data.mySale = $$sale.new()
    }

    if (storageHandler.get('scrapping.area.new')) {
      $$area.data.myAreaSearchdata = storageHandler.get('scrapping.area.new')
    } else {
      $$area.data.myAreaSearchdata = $$area.new()
    }

    if (storageHandler.get('scrapping.railway.new')) {
      $$railway.data.myRailwaySearchdata = storageHandler.get('scrapping.railway.new')
    } else {
      $$railway.data.myRailwaySearchdata = $$railway.new()
    }
  })

  $transitions.onBefore({
    from: routes.scrapping.sale.new.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('scrapping.sale.new', $$sale.data.mySale)
      storageHandler.save('scrapping.area.new', $$area.data.myAreaSearchdata)
      storageHandler.save('scrapping.railway.new', $$railway.data.myRailwaySearchdata)

      $$sale.data.mySale = null
      $$area.data.myAreaSearchdata = null
      $$railway.data.myRailwaySearchdata = null
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.details.path,
  }, async (trans) => {
    try {
      const saleId = $$sale.local.getCurrentId()
      $$sale.data.mySale = await $$sale.request.getById(saleId)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.edit.path,
  }, async (trans) => {
    const id = $$sale.local.getCurrentId()
    const data = {
      saleId: id,
    }

    try {
      const sale = await $$sale.request.getById(id)
      const response = await $$wagon.request.getBySearch(data)
      $$sale.data.mySale = $$sale.format.user(sale)
      $$wagon.data.myWagons = response.wagons
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.axletrees.path,
  }, async (trans) => {
    const data = {
      wagonId: $$wagon.local.getCurrentScrappedId(),
    }
    try {
      if (!$$sale.data.mySale) {
        const saleId = $$sale.local.getCurrentId()
        $$sale.data.mySale = await $$sale.request.getById(saleId)
      }

      const response = await $$axletree.request.getBySearch(data)
      const axletrees = response.axletrees
      $$axletree.data.myAxletrees.splice(0, $$axletree.data.myAxletrees.length)
      for (let index = 0; index < axletrees.length; index++) {
        const axletree = axletrees[index]
        $$axletree.data.myAxletrees.push($$axletree.format.user(axletree))
      }

      const defaultWeight = $$sale.data.mySale.axletreeDefaultWeight || 1300
      const length = $$axletree.data.myAxletrees.length
      if (length < 1) {
        $$axletree.data.myAxletrees.push($$axletree.new(defaultWeight, length))
      }
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.pieces.path,
  }, async (trans) => {
    const data = {
      wagonId: $$wagon.local.getCurrentScrappedId(),
    }

    try {
      const response = await $$piece.request.getBySearch(data)
      const pieces = response.pieces
      $$piece.data.myPieces = $$piece.format.user(pieces)
      const length = $$piece.data.myPieces.length
      if (length < 1) {
        $$piece.data.myPieces.push($$piece.new(length))
      }
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.steriles.path,
  }, async (trans) => {
    const data = {
      wagonId: $$wagon.local.getCurrentScrappedId(),
    }
    try {
      const response = await $$sterile.request.getBySearch(data)
      const steriles = response.steriles
      $$sterile.data.mySteriles = $$sterile.format.user(steriles)
      const length = $$sterile.data.mySteriles.length
      if (length < 1) {
        $$sterile.data.mySteriles.push($$sterile.new(length))
      }
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.generateBLWagons.path,
  }, async (trans) => {
    try {
      const saleId = $$sale.local.getCurrentId()
      $$sale.data.mySale = await $$sale.request.getById(saleId)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    entering: routes.scrapping.sale.generateBLEssieux.path,
  }, async (trans) => {
    try {
      const saleId = $$sale.local.getCurrentId()
      $$sale.data.mySale = await $$sale.request.getById(saleId)
    } catch (error) {
      toaster.error(error)
    }
  })
}

export default saleRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/sale/sale.run.js